import { GET, POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/voucher-theme/${endpoint}`;
};

export const getVoucherThemes = (token, page, pageSize) => {
  const endpoint = getEndpointWithPrefix(`get-all/?page=${page}&pageSize=${pageSize}`);
  return GET(endpoint, token);
};

export const getVoucherThemeCategories = (token) => {
  const endpoint = getEndpointWithPrefix(`category`);
  return GET(endpoint, token);
};

export const AddVoucherThemesApi = (token, data) => {
  const endpoint = getEndpointWithPrefix(`add`);
  return POST(endpoint, token, data);
};

export const updateVoucherTheme = (token, data) => {
  const endpoint = getEndpointWithPrefix(`update`);
  return PUT(endpoint, token, data);
};